import React, { useEffect, useMemo, useState } from 'react';
import UserService from '../services/user/UserService';

const UPT = ({ id, type = "panjang" }) => {
    const userService = useMemo(() => new UserService(), []);
    const [urUpt, setUrUpt] = useState('');

    useEffect(() => {
        if (!id || id === "null" || id === "undefined") {
            setUrUpt("");
            return;
        }

        const getUpt = async () => {
            try {
                const response = await userService.getUptById(id);

                const data = response.data;

                let result = "";

                if (type === "pendek") {
                    result = data.nmPendekBaru?.trim() + ' d/h ' + data.nmPendek?.trim() || "";
                } else {
                    result = data.nmUnitBaru?.trim() + ' d/h ' + data.nmUnit?.trim() || "";
                }

                setUrUpt(result);

            } catch (error) {
                console.error("Gagal load UPT:", error);
                setUrUpt("");
            }
        };

        getUpt();
    }, [userService, id, type]);

    return <>{urUpt}</>;
};

export default UPT;